export const FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_SUCCESS = 'FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_SUCCESS';

export const findPseudonymByModuleAndCareProviderSuccess = pseudonym => ({
    type: FIND_PSEUDONYM_BY_MODULE_AND_CARE_PROVIDER_SUCCESS,
    payload: { pseudonym },
});
